import React, { useEffect, useRef } from "react";

const AiComm = () => {
    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="relative bg-black text-white min-h-screen overflow-hidden font-sans">

            {/* Navbar / Top Header removed - moved to global Header */}

            {/* Hero Section */}
            <section className="relative z-10 min-h-[calc(100vh-80px)] flex items-center px-6 pt-10 pb-20 bg-cover bg-center bg-no-repeat" style={{ backgroundImage: "url('/images/bot2.png')" }}>
                <div className="absolute inset-0 bg-black/60"></div> {/* Overlay for readability */}

                <div className="relative z-20 max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2">
                    <div className="text-left mt-32">
                        <h1 className="text-3xl md:text-5xl font-bold mb-6 text-white leading-tight drop-shadow-2xl max-w-2xl">
                            Sit back while AI handles chats, WhatsApp, and calls.
                        </h1>
                        <p className="text-gray-200 text-lg md:text-xl mb-10 leading-relaxed drop-shadow-lg font-light max-w-lg">
                            One platform for all your customer conversations.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-start">
                            <button onClick={() => scrollToSection('features')} className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-full font-bold text-lg shadow-lg hover:shadow-blue-500/50 transition-all transform hover:-translate-y-1">
                                Discover Features
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* Features Section */}
            <section id="features" className="relative z-10 py-24 px-6 bg-gradient-to-b from-gray-900 to-gray-950">
                <div className="max-w-7xl mx-auto">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                        {/* Left: Text */}
                        <div className="text-left">
                            <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white leading-tight">
                                All Chat, WhatsApp, <br /> call are at one place.
                            </h2>
                            <p className="text-gray-300 text-xl md:text-2xl leading-relaxed">
                                Managing customer communication and history become super easy.
                            </p>
                        </div>

                        {/* Right: Video */}
                        <div className="relative group rounded-2xl overflow-hidden shadow-2xl border border-gray-800">
                            <video
                                className="w-full h-auto"
                                controls
                                poster="" // Optional: Add a poster image if available
                            >
                                <source src="/doclift-ppt.mp4" type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>
                </div>
            </section>

            {/* Benefits Section */}
            <section id="benefits" className="relative z-10 py-24 px-6 bg-gray-950">
                <div className="max-w-5xl mx-auto">
                    <h2 className="text-3xl md:text-5xl font-bold text-center mb-16 text-white">Benefits</h2>
                    <div className="grid gap-6">
                        {[
                            "Never miss a customer inquiry — AI responds instantly to chats, WhatsApp messages, and calls 24/7.",
                            "Saves staff time and cost by automating repetitive questions and appointment bookings.",
                            "Faster response = more conversions — quick replies help turn inquiries into customers.",
                            "Handles high volume effortlessly during busy hours without delays or hold times.",
                            "Provides consistent, accurate communication with automated reminders, follow-ups, and records."
                        ].map((benefit, index) => (
                            <div key={index} className="bg-gray-900/50 border border-gray-800 p-6 rounded-xl flex items-start space-x-4 hover:border-blue-500/50 transition-colors">
                                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-500/20 text-blue-400 flex items-center justify-center mt-1">
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
                                </span>
                                <p className="text-gray-300 text-lg">{benefit}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Footer CTA */}
            <section className="text-center py-20 bg-gradient-to-r from-blue-900/40 via-purple-900/40 to-pink-900/40 relative z-10">
                <h2 className="text-3xl font-bold mb-6">Ready to transform your communication?</h2>
                <button className="bg-white text-gray-900 px-8 py-4 rounded-full font-bold text-lg shadow-lg hover:bg-gray-100 transition-colors">
                    Get Started Now
                </button>
            </section>
        </div>
    );
};

export default AiComm;
